import React from "react";
import { Add } from "@mui/icons-material";
import { Box, Button, Divider, Typography } from "@mui/material";
import { toast } from "react-toastify";
import { useTablePagination } from "hooks";
import {
    useAddDocumentSourceForVendorMutation,
    useGetDocumentsBySourceQuery,
} from "store/services/documentApi";
import VendorProfileDocumentForm from "./VendorProfileDocumentForm";
import VendorProfileDocumentList from "./VendorProfileDocumentList";
import FormDrawer from "components/Shared/FormDrawer";

const SOURCE = "VendorProfile";

const VendorProfileDocumentsSection = ({ profile }) => {
    const sourceRef = profile?._id;

    const { currentPage, perPage, handlePageChange, handlePerRowsChange } =
        useTablePagination();

    const [showDocumentForm, setShowDocumentForm] = React.useState(false);

    const { data: documents, isLoading: loadingDocuments } =
        useGetDocumentsBySourceQuery(
            { source: SOURCE, sourceRef, active: "all" },
            { skip: !sourceRef }
        );

    const [addDocumentSource, { isLoading: addingDoc }] =
        useAddDocumentSourceForVendorMutation();

    const handleAddDocument = async (document) => {
        try {
            await addDocumentSource({
                documents: [document],
                source: SOURCE,
                sourceRef,
            }).unwrap();
            toast.success("Document successfully added!");
            setShowDocumentForm(false);
        } catch (err) {
            toast.error(err?.data?.message ?? "Couldn't add document!");
        }
    };

    return (
        <>
            <Divider sx={{ my: 2 }} />
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 1,
                }}
            >
                <Typography variant="h6" color="primary" gutterBottom>
                    Documents
                </Typography>
                <Button
                    size="small"
                    startIcon={<Add />}
                    variant="outlined"
                    onClick={() => setShowDocumentForm(true)}
                >
                    Document
                </Button>
            </Box>
            <VendorProfileDocumentList
                documents={documents?.data}
                isBusy={loadingDocuments}
                totalDocuments={documents?.totalItems}
                perPage={perPage}
                currentPage={currentPage}
                handlePageChange={handlePageChange}
                handlePerRowsChange={handlePerRowsChange}
            />
            <FormDrawer
                open={showDocumentForm}
                onClose={() => setShowDocumentForm(false)}
            >
                <VendorProfileDocumentForm
                    isBusy={addingDoc}
                    onSubmit={handleAddDocument}
                    onCancel={() => setShowDocumentForm(false)}
                />
            </FormDrawer>
        </>
    );
};

export default VendorProfileDocumentsSection;